export const routes = {
  inscription: '/inscription',
  demarrage: '/demarrage/bienvenue',
  onboarding: '/onboarding',
  schoolyearsSettings: '/mes-annees-scolaires',
  schoolyearSettings: ({ schoolyearId }: { schoolyearId: string }) =>
    `${routes.schoolyearsSettings}/${schoolyearId}`,
  schoolBase: ({
    schoolyearId,
    schoolId,
  }: {
    schoolyearId: string;
    schoolId: string;
  }) => `${routes.schoolyearSettings({ schoolyearId })}/ecoles/${schoolId}`,
};
